import { HttpClient } from '@angular/common/http';
import { Options } from '@angular-slider/ngx-slider';

import { TranslateLoader, TranslateService } from '@ngx-translate/core';

import { IconDefinition, IconName } from '@fortawesome/fontawesome-svg-core';

import { CustomTranslocoHttpLoader } from './transloco/loader';
import { of } from 'rxjs';

export function HttpLoaderFactory(http: HttpClient) {
  return new CustomTranslocoHttpLoader(http);
}

export function appInitializerFactory(translate: TranslateService) {
  return () => {
    translate.setDefaultLang('de');
    return translate.use('de');
  };
}

export const faRoad: IconDefinition = {
  prefix: 'far',
  iconName: 'road' as IconName,
  icon: [
    512,
    512,
    [],
    'f031',
    'M282.243,97.396C282.243,83.598 271.041,72.396 257.243,72.396C243.445,72.396 232.243,83.598 232.243,97.396L232.243,137.668C232.243,151.466 243.445,162.668 257.243,162.668C271.041,162.668 282.243,151.466 282.243,137.668L282.243,97.396Z' +
      'M282.243,392.437C282.243,378.64 271.041,367.437 257.243,367.437C243.445,367.437 232.243,378.64 232.243,392.437L232.243,432.71C232.243,446.508 243.445,457.71 257.243,457.71C271.041,457.71 282.243,446.508 282.243,432.71L282.243,392.437Z' +
      'M282.243,230.053C282.243,216.255 271.041,205.053 257.243,205.053C243.445,205.053 232.243,216.255 232.243,230.053L232.243,300.053C232.243,313.851 243.445,325.053 257.243,325.053C271.041,325.053 282.243,313.851 282.243,300.053L282.243,230.053Z' +
      'M159.143,93.31C162.715,79.982 154.793,66.263 141.466,62.691C128.138,59.12 114.418,67.041 110.847,80.369L15.343,436.796C11.772,450.123 19.693,463.843 33.021,467.414C46.348,470.986 60.068,463.064 63.639,449.737L159.143,93.31Z' +
      'M403.639,80.369C400.068,67.041 386.348,59.12 373.021,62.691C359.693,66.263 351.772,79.982 355.343,93.31L450.847,449.737C454.418,463.064 468.138,470.986 481.466,467.414C494.793,463.843 502.715,450.123 499.143,436.796L403.639,80.369Z',
  ],
};

export class FakeLoader implements TranslateLoader {
  public getTranslation(_) {
    return of(require('src/assets/i18n/en.json'));
  }
}

export const sliderBaseOptions: Options = {
  floor: 0,
  ceil: 1,
  showTicks: false,
  showTicksValues: false,
  hideLimitLabels: true,
  hidePointerLabels: true,
  animate: true,
};
